"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyStatesConfig = void 0;
var getEmptyStatesConfig = function (_a) {
    var preset = _a.preset, title = _a.title, contentTypeTitle = _a.contentTypeTitle, commaSeparatedTags = _a.commaSeparatedTags, localize = _a.localize;
    switch (preset) {
        case "multipleCollectionsListing":
            return {
                align: "center",
                image: {
                    src: "contentListing",
                    style: {
                        height: 80,
                        opacity: 0.6,
                    },
                },
                title: "No tags added",
                subtitle: localize("Publishing under <word1 : ".concat(commaSeparatedTags, "> shows all tagged content here, You can edit published content in future, when required.")),
            };
        case "multiplePublishingListing":
            return {
                align: "center",
                image: {
                    src: "contentListing",
                    style: {
                        height: 80,
                        opacity: 0.6,
                    },
                },
                title: "No Content Added",
                subtitle: "Once you publish content on the platform, it shows up here. You can edit published content in future, when required. ",
            };
        case "singlePublishingListing":
            return {
                align: "center",
                image: {
                    src: "contentListing",
                    style: {
                        height: 80,
                        opacity: 0.6,
                    },
                },
                title: "No ".concat(contentTypeTitle === null || contentTypeTitle === void 0 ? void 0 : contentTypeTitle.toLowerCase(), " Added"),
                subtitle: localize("Publishing under <word1 : ".concat(contentTypeTitle === null || contentTypeTitle === void 0 ? void 0 : contentTypeTitle.toLowerCase(), "> shows your content here, You can edit published content in future, when required.")),
            };
        case "singleCollectionsListing":
            return {
                align: "center",
                image: {
                    src: "contentListing",
                    style: {
                        height: 80,
                        opacity: 0.6,
                    },
                },
                imageSize: 80,
                title: "No ".concat(contentTypeTitle === null || contentTypeTitle === void 0 ? void 0 : contentTypeTitle.toLowerCase(), " Added"),
                subtitle: localize("Publishing under <word1 : ".concat(contentTypeTitle === null || contentTypeTitle === void 0 ? void 0 : contentTypeTitle.toLowerCase(), "> shows your content here, You can edit published content in future, when required.")),
            };
        case "profileListing":
            return {
                align: "center",
                image: {
                    src: "contentListing",
                    style: {
                        height: 80,
                        opacity: 0.6,
                    },
                },
                title: "No Profile Added",
                subtitle: "Once you publish any profile on the platform, it shows up here. You can edit profile content in future, when required. ",
            };
        case "notificationEmpty":
            return {
                align: "center",
                image: {
                    src: "mailBoxImg",
                    style: {
                        height: 80,
                        opacity: 0.6,
                    },
                },
                title: "No Notifications Yet",
                subtitle: "All updates,notifications and alerts will be displayed here ",
            };
        case "dashboardListing":
            return {
                align: "center",
                image: {
                    src: "dashboardListing",
                    style: {
                        height: 80,
                        opacity: 0.6,
                    },
                },
                title: "No Data Added",
                subtitle: "Currently, no data is available. Start exploring insights once data is populated ",
            };
        case "successFullyPublish":
            return {
                align: "center",
                // image: {
                //   src: "congratulationsImg",
                //   style: {
                //     height: 150,
                //     opacity: 1,
                //   },
                // },
                title: title || "Content Published Successfully",
                subtitle: " ",
            };
        case "draftsListing":
            return {
                align: "left",
                image: {
                    src: "draftsListing",
                    style: {
                        height: 80,
                    },
                },
                title: "No Drafts Found",
                subtitle: "Once you publish any content on the platform, it shows up here. You can edit published content in future, when required.",
                button: {
                    // route: "/choose-template",
                    text: "Start Writing",
                },
            };
        case "publishedListing":
            return {
                align: "left",
                image: {
                    src: "publishedListing",
                    style: {
                        height: 80,
                    },
                },
                title: "No published content found",
                subtitle: "Once you publish any content on the platform, it shows up here. You can edit published content in future, when required.",
                button: {
                    // route: "/choose-template",
                    text: "Start Writing",
                },
            };
        case "inModerationListing":
            return {
                align: "left",
                image: {
                    src: "moderationListing",
                    style: {
                        height: 80,
                    },
                },
                title: "No content sent for moderation",
                subtitle: "Once you publish any content on the platform, it shows up here. You can edit published content in future, when required.",
                button: {
                    // route: "/choose-template",
                    text: "Start Writing",
                },
            };
        case "underMyModeration":
            return {
                align: "left",
                image: {
                    src: "moderationListing",
                    style: {
                        height: 80,
                    },
                },
                title: "No published content under my moderation",
                subtitle: "Once you publish any content on the platform, it shows up here. You can edit published content in future, when required.",
            };
        case "underOthersModeration":
            return {
                align: "left",
                image: {
                    src: "moderationListing",
                    style: {
                        height: 80,
                    },
                },
                title: "No published content under others moderation",
                subtitle: "Once you publish any content on the platform, it shows up here. You can edit published content in future, when required.",
            };
        case "awaitingMod":
            return {
                align: "left",
                image: {
                    src: "moderationListing",
                    style: {
                        height: 80,
                    },
                },
                title: "No published content under awaiting moderation",
                subtitle: "Once you publish any content on the platform, it shows up here. You can edit published content in future, when required.",
            };
        case "searchListing":
            return {
                align: "center",
                image: {
                    src: "searchListing",
                    style: {
                        opacity: 0.6,
                    },
                },
                title: localize("Cant find any content for <word1 : ".concat(contentTypeTitle, ">")),
                subtitle: "Sorry we couldn’t find any matches for this. Please make sure the words are spelled correctly",
                link: {
                    // onClick: action,
                    text: "Clear Search",
                },
            };
        case "searchDashBoardListing":
            return {
                align: "center",
                image: {
                    src: "searchDashBoardListing",
                    style: {
                        opacity: 0.6,
                    },
                },
                title: "No search results found",
                subtitle: "Sorry we couldn’t find any matches for this. Please make sure the words are spelled correctly ",
            };
    }
};
exports.getEmptyStatesConfig = getEmptyStatesConfig;
